import React, { createContext, useContext, useState, useEffect } from 'react';
import EntriesService from '../entries.service';

const EntriesServiceContext = createContext();

export const EntriesServiceProvider = ({ children }) => {
  const [displayData, setDisplayData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Initialize the service with state updaters
    EntriesService.setStateUpdaters(setDisplayData, setLoading);
    EntriesService.initializeState([], false);
  }, []);

  const contextValue = {
    displayData,
    setDisplayData,
    loading,
    setLoading,
    service: EntriesService
  };

  return (
    <EntriesServiceContext.Provider value={contextValue}>
      {children}
    </EntriesServiceContext.Provider>
  );
};

export const useEntriesService = () => {
  const context = useContext(EntriesServiceContext);
  if (context === undefined) {
    throw new Error('useEntriesService must be used within a EntriesServiceProvider');
  }
  return context;
};

// Keep the old hook name for backward compatibility during transition
export const useInboxService = () => {
  const context = useContext(EntriesServiceContext);
  if (context === undefined) {
    throw new Error('useInboxService must be used within a EntriesServiceProvider');
  }
  return context;
};

export default EntriesServiceContext;
